// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.QRCodeScanner_riskButton__KAFoI {
    margin-bottom: 2rem;
}`, "",{"version":3,"sources":["webpack://./src/pages/QRCodeScanner/QRCodeScanner.module.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;AACvB","sourcesContent":[".riskButton {\r\n    margin-bottom: 2rem;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"riskButton": `QRCodeScanner_riskButton__KAFoI`
};
export default ___CSS_LOADER_EXPORT___;
